export const ZOOM_LEVELS = {
    STATE:  { MIN: 6.8, MAX: 8.5 },
    COUNTY: { MIN: 8.5, MAX: 14 }, 
    GEOBLK: { MIN: 13, MAX: 20 },
  };

export const WELL_ZOOM_LEVELS = {
    STATE:  { MIN: 6.8, MAX: 9 },
    COUNTY: { MIN: 9, MAX: 14 }, 
    GEOBLKGROUP: { MIN: 14, MAX: 18 },
  };

export const COUNTY_ZOOM_LEVEL = 8.5;
export const WELL_COUNTY_ZOOM_LEVEL = 9.5;
export const WELL_GEOBLOCK_ZOOM_LEVEL = 14;